import { $el, $list } from 'src/scripts/utils/utils'
import { BaseComponent } from '../../components/base-component'

const LOGIN_FORM_SELECTOR = '[data-login-form]'

export class LoginComponent extends BaseComponent {
  mountComponent(): void {
    this.updateFocus()
    this.addListener(this, 'click', this.handleClick)
  }

  handleClick = (event: MouseEvent): void => {
    const target = event.target as HTMLElement
    const isLoginFormButton = target.hasAttribute('data-login-form-button')

    if (isLoginFormButton) {
      const loginFormId = target.dataset.loginFormId || ''

      this.setFormVisibleById(loginFormId)
      this.updateFocus()
    }
  }

  setFormVisibleById(loginFormId: string): void {
    const forms = $list(LOGIN_FORM_SELECTOR, this)

    forms.forEach(form => {
      const isTargetForm = form.getAttribute('data-login-form') === loginFormId
      form.classList.toggle('hidden', !isTargetForm)
    })
  }

  updateFocus(): void {
    const forms = $list(LOGIN_FORM_SELECTOR, this)

    forms.forEach(form => {
      const isHidden = form.classList.contains('hidden')
      const emailInput: HTMLInputElement = $el('[type="email"]', form)

      if (!isHidden && emailInput) {
        emailInput.focus()
      }
    })
  }
}
